import { forwardRef, type Ref, type SVGProps } from "react";
const IconHourglassOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M13 11a3.19 3.19 0 0 0 3 3 3.19 3.19 0 0 0 3-3z" />
    <path d="M27 28h-1.17c-.67-4.48-3.27-10.5-5.8-12 2.53-1.5 5.13-7.52 5.8-12H27a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2h1.17C6.84 8.48 9.44 14.5 12 16c-2.53 1.5-5.13 7.52-5.8 12H5a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2m-5 0c0-3-4.5-7-6-7s-6 4-6 7H8.18c.67-4 3-9.2 4.81-10.28a2 2 0 0 0 0-3.44C11.17 13.2 8.85 8 8.18 4h15.64c-.67 4-3 9.2-4.81 10.28a2 2 0 0 0 0 3.44C20.83 18.8 23.15 24 23.82 28z" />
  </svg>
);
const ForwardRef = forwardRef(IconHourglassOutlineSVG);
ForwardRef.displayName = "IconHourglassOutline";
export { ForwardRef as IconHourglassOutline };
